import { newSeason } from "@/mocks/home";

export default function NewSeason() {
  return (
    <section id="new" className="relative w-full py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm tracking-widest text-primary-400">NEW SEASON</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">本季新番速递</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
              夏季档最新开播与热播作品抢先看，评分与简介一目了然，帮你快速锁定本季必追。
            </p>
          </div>
          <a
            href="#category"
            className="inline-flex items-center gap-1 text-sm text-primary-300 whitespace-nowrap transition-colors hover:text-primary-200"
          >
            浏览全部分类 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-6">
          {newSeason.map((item) => (
            <article
              key={item.id}
              className="group relative overflow-hidden rounded-lg border border-background-800/70 bg-background-900 transition-colors hover:border-primary-500/60"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 动漫海报`}
                  title={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-2 top-2 rounded bg-primary-500 px-2 py-0.5 text-[11px] text-background-50">
                  {item.season}
                </span>
                <span className="absolute right-2 top-2 rounded bg-background-950/80 px-2 py-0.5 text-xs text-accent-300">
                  {item.score.toFixed(1)}
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate text-sm font-medium text-foreground-100">{item.title}</h3>
                <p className="mt-1.5 flex flex-wrap gap-1">
                  {item.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded bg-background-800 px-1.5 py-0.5 text-[10px] text-foreground-400"
                    >
                      {t}
                    </span>
                  ))}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}